import { createReducer, on } from '@ngrx/store';
import {
  storePricingFormState
} from './pricing-form.actions';

export interface PricingFormState {
  formState: Record<string, unknown>;
}

export const pricingFormFeatureKey = 'pricingFormState';

export interface AssociationsPricingFormMap {
    [key: string]: PricingFormState;
} 
export interface IPricingFormState {
    associations: AssociationsPricingFormMap;
    formState: Record<string, unknown>;
}
export const initialPricingFormState: IPricingFormState = {
    associations: {},
    formState: {}
};

export const pricingFormReducer = createReducer(
  initialPricingFormState,
  on(storePricingFormState, (state, { formState }): IPricingFormState => {
    //console.log('pricing-form, storePricingFormState, formState', formState);
    let rtn = { ...state, formState };       
    return rtn;// { ...state, formState }
  }),

);
